<script>
import combineProduct from "@/util/combineProduct.js";
import findProductInCart from "@/util/findProductInCart.js";
import { mapState, mapActions } from "vuex";

export default {
  name: "ProductPage",
  props: {
    product: {
      type: Object,
      required: true,
    },
    baseUrl: {
      type: String,
      required: true,
    },
    currentColorId: null,
  },
  data() {
    let initalColorIndex = 0;

    if (this.currentColorId) {
      for (var index in this.product.colors) {
        const color = this.product.colors[index];
        if (color.uuid == this.currentColorId) {
          initalColorIndex = index;
          break;
        }
      }
    }

    return {
      currentColorIndex: initalColorIndex,
      bigImageLoading: false,
      isPopupImagesVisible: false,
    };
  },
  computed: {
    currentColor() {
      return this.product.colors[this.currentColorIndex];
    },
    сanBeBought() {
      return !this.currentColor.not_available && this.currentColor.price > 0;
    },
    isInFavorites() {
      const favoritesId = this.product.id + ":" + this.currentColor.uuid;
      return this.favorites.indexOf(favoritesId) !== -1;
    },
    ...mapState(["cart", "favorites"]),
  },
  watch: {},
  methods: {

    processUrl(url) {
      // Замена "/imagine/original/" на "/cache/imagine-webp/"
      let processedUrl = url.replace(/\/imagine\/original\//, "/cache/imagine-webp/");

      // Если URL заканчивается на ".jpg", замена на ".jpg.webp"
      if (processedUrl.endsWith(".jpg")) {
        processedUrl = processedUrl.replace(".jpg", ".jpg.webp");
      }

      return processedUrl;
    },
    setCurrentColor(index) {
      this.bigImageLoading = true;
      this.currentColorIndex = index;
      this.$nextTick(() => {
        history.pushState(
          { colorIndex: index },
          null,
          this.baseUrl + (index != 0 ? "/color/" + this.currentColor.uuid : "")
        );
        if (this.$refs.bigImage.complete) {
          this.bigImageLoading = false;
        }
      });
    },
    openPopupImages(selector) {
      this.isPopupImagesVisible = true;
      document.body.classList.add("noscroll");
      this.$nextTick(() => {
        const scroller = this.$refs.popupImagesScroller;
        const child = scroller.querySelector(selector);
        scroller.scrollTop = child.offsetTop;
      });
    },
    closePopupImages() {
      this.isPopupImagesVisible = false;
      document.body.classList.remove("noscroll");
    },
    scrollToImages(ref) {
      window.scrollTo({
        top: (this.$refs[ref][0] || this.$refs[ref]).offsetTop - 110,
        behavior: "smooth",
      });
    },
    isProductInCart(productId, colorId) {
      return findProductInCart(this.cart, productId, colorId) !== null;
    },
    addToFavorites() {
      const favoritesId = this.product.id + ":" + this.currentColor.uuid;
      this.addProductToFavorites(favoritesId);
    },
    removeFromFavorites() {
      const favoritesId = this.product.id + ":" + this.currentColor.uuid;
      const index = this.favorites.indexOf(favoritesId);
      this.removeProductFromFavorites(index);
    },
    toggleInFavorites() {
      if (this.isInFavorites) {
        this.removeFromFavorites();
      } else {
        this.addToFavorites();
      }
    },
    buy() {
      this.$store.dispatch(
        "addProductToCart",
        combineProduct(this.product, this.currentColor)
      );
    },
    toCharacteristics() {
      this.$refs.characteristics.open();
      const top = this.$refs.characteristics.$el.offsetTop - 110;
      scrollTo({ top: top, behavior: "smooth" });
    },
    toVideo() {
      this.$refs.video.open();
      const top = this.$refs.video.$el.offsetTop - 110;
      scrollTo({ top: top, behavior: "smooth" });
    },
    open1ClickForm() {
      const title =
        this.product.collection.title +
        " " +
        this.product.title +
        " " +
        this.product.description +
        ", цвет: " +
        this.currentColor.title +
        " [" +
        this.currentColor.sku +
        "]";
      this.$root.open1ClickForm(title);
    },
    ...mapActions(["addProductToFavorites", "removeProductFromFavorites"]),
  },
  mounted() {
    if (this.$refs.bigImage) {
      this.$refs.bigImage.addEventListener("load", () => {
        this.bigImageLoading = false;
      });
    }
  },
};
</script>

<template>
  <div class="product-page">
    <div class="left-column">
      <div class="block info-blocks">
        <h1 class="page-title">{{ product.title }}</h1>
        <div class="mobile-product-photo">
          <img
                  class="big-image"
                  ref="bigImage"
                  :src="processUrl(currentColor.coverImage.bigImg)"
                  @click="
                    openPopupImages(
                      '.popup-image-' + currentColor.coverImage.checksum
                    )
                  "
          />

          <div
                  v-if="
              currentColor &&
              currentColor.images &&
              currentColor.images.length > 0
            "
                  class="images"
          >
            <div
                    v-for="image in currentColor.images"
                    :key="image.checksum"
                    :ref="'image-' + image.checksum"
                    class="image-wrap"
            >
              <div class="image-wrap2">
                <div class="image-wrap3">
                  <img
                          class="image"
                          :src="processUrl(image.smallImg)"
                          @click="openPopupImages('.popup-image-' + image.checksum)"
                  />
                </div>
              </div>
            </div>
          </div>

        </div>
        <div v-if="product.collection" class="collection">
          {{ $s("STR_COLLECTION") }} {{ product.collection.title }}
        </div>
        <div v-if="currentColor && currentColor.sku" class="sku">
          {{ $s("STR_SKU") }}: {{ currentColor.sku }}
        </div>
        <div v-if="product.description" class="description">
          {{ product.description }}
        </div>
        <div
          class="available"
          :class="[
            currentColor.not_available ? 'not-available' : 'is-available',
          ]"
        >
          {{
            currentColor.not_available
              ? $s("STR_NOT_AVAILABLE")
              : $s("STR_PRODUCT_IN_STOCK")
          }}
        </div>
        <div v-if="currentColor.price_old" class="price-old">
          {{ $moneyFormat(currentColor.price_old) }}
        </div>
        <div v-if="currentColor.price" class="price">
          {{ $moneyFormat(currentColor.price) }}
        </div>
        <div class="actions">
          <a class="action" @click="toCharacteristics">
            <div class="icon-wrap">
              <icon-details />
            </div>
            Характеристики
          </a>
          <a
            class="action"
            @click="toggleInFavorites"
            :class="{ 'is-active': isInFavorites }"
          >
            <div class="icon-wrap">
              <icon-favorites30 />
            </div>
            <template v-if="!isInFavorites"> Добавить в Избранное </template>
            <template v-if="isInFavorites"> Убрать из Избранного </template>
          </a>
        </div>
      </div>


    <template  v-if="product.page_id && [35,86,87,100,101,102,103,104,105,106,107,108,109, 152].indexOf(parseInt(product.page_id)) === -1">

      <div class="block size-block" >
        <div class="label">
          <span class="caption">Размер</span> {{ product.size_height }} x
          {{ product.size_width }} x {{ product.size_depth }} {{ $s("STR_CM") }}
        </div>
        <div class="other-sizes">
          <a
            v-for="otherSize in product.otherSizes"
            :key="otherSize.id"
            class="size-button"
            :class="{ 'is-current': otherSize.is_current }"
            :href="otherSize.url"
            >{{ otherSize.title }}</a
          >
        </div>
      </div>
    </template>
      <div class="block colors-block">
        <div class="label">
          <span class="caption">Цвет</span> {{ currentColor.title }}
        </div>
        <div class="colors">
          <template v-for="(color, index) in product.colors" :key="color.uuid">
            <button
              v-if="color.color_image && color.color_image != 'null'"
              type="button"
              class="color"
              :class="{ selected: currentColorIndex == index }"
              :style="{
                backgroundImage:
                  'url(/download/files/' + color.color_image + ')',
              }"
              :title="color.title"
              @click="setCurrentColor(index)"
            ></button>
            <button
              v-else
              type="button"
              class="color"
              :class="{ selected: currentColorIndex == index }"
              :style="{
                backgroundColor: color.color || '#000000',
              }"
              :title="color.title"
              @click="setCurrentColor(index)"
            ></button>
          </template>
        </div>
      </div>


      <div v-if="сanBeBought" class="block buttons-block">
        <button
          v-if="!isProductInCart(product.id, currentColor.uuid)"
          type="button"
          class="buy"
          @click="buy"
        >
          Купить
        </button>
        <button v-else type="button" class="buy" @click="buy">
          {{ $s("STR_ALREADY_IN_CART") }}
        </button>
        <button type="button" class="fast-buy" @click="open1ClickForm">
          Купить в 1 клик
        </button>
      </div>

      <div class="content-block" ref="content" v-if="product.content">
        <div class="content-title">Описание</div>
        <article class="content-text" v-html="product.content"></article>
      </div>
    </div>
    <div class="right-column">
      <div
        v-if="
          (currentColor && currentColor.coverImage) ||
          (currentColor &&
            currentColor.images &&
            currentColor.images.length > 0)
        "
        class="images-wrap"
      >
        <div class="images-wrap2">
          <template v-if="currentColor && currentColor.coverImage">
            <div
              :ref="'image-' + currentColor.coverImage.checksum"
              class="big-image-wrap"
            >
              <div class="big-image-wrap2">
                <img
                  class="big-image"
                  ref="bigImage"
                  :src="processUrl(currentColor.coverImage.bigImg)"
                  @click="
                    openPopupImages(
                      '.popup-image-' + currentColor.coverImage.checksum
                    )
                  "
                />
                <transition name="fade-03">
                  <div v-if="bigImageLoading" class="loading"></div>
                </transition>
              </div>
            </div>
          </template>
          <div
            v-if="
              currentColor &&
              currentColor.images &&
              currentColor.images.length > 0
            "
            class="images"
          >
            <div
              v-for="image in currentColor.images"
              :key="image.checksum"
              :ref="'image-' + image.checksum"
              class="image-wrap"
            >
              <div class="image-wrap2">
                <div class="image-wrap3">
                  <img
                    class="image"
                    :src="image.smallImg"
                    @click="openPopupImages('.popup-image-' + image.checksum)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="thumbnails-wrap">
          <div class="thumbnails-wrap2">
            <perfect-scrollbar class="thumbnails">
              <div v-if="product.video" class="thumbnail-wrap" @click="toVideo">
                <icon-video></icon-video>
              </div>
              <div
                v-if="currentColor && currentColor.coverImage"
                class="thumbnail-wrap"
              >
                <img
                  class="thumbnail-image"
                  :src="currentColor.coverImage.thumbnailImg"
                  @click="
                    scrollToImages('image-' + currentColor.coverImage.checksum)
                  "
                />
              </div>
              <template
                v-if="
                  currentColor &&
                  currentColor.images &&
                  currentColor.images.length > 0
                "
              >
                <div
                  v-for="image in currentColor.images"
                  :key="image.checksum"
                  class="thumbnail-wrap"
                >
                  <img
                    class="thumbnail-image"
                    :src="image.thumbnailImg"
                    @click="scrollToImages('image-' + image.checksum)"
                  />
                </div>
              </template>
            </perfect-scrollbar>
          </div>
        </div>
      </div>

      <div
        v-if="
          product.video || product.characteristics || product.delivery_payment
        "
        class="text-blocks"
      >
        <text-expander ref="video" v-if="product.video">
          <template v-slot:title>{{ $s("STR_VIDEO") }}</template>
          <div v-html="product.video"></div>
        </text-expander>
        <text-expander ref="characteristics" v-if="product.characteristics">
          <template v-slot:title>{{ $s("STR_CHARACTERISTICS") }}</template>
          <div v-html="product.characteristics"></div>
        </text-expander>
        <text-expander ref="deliveryPayment" v-if="product.delivery_payment">
          <template v-slot:title>{{
            $s("STR_DELIVERY_PAYMENT_RETURN")
          }}</template>
          <div v-html="product.delivery_payment"></div>
        </text-expander>
      </div>
    </div>
    <transition name="fade-05">
      <div v-if="isPopupImagesVisible" class="popup-image">
        <button type="button" class="close" @click="closePopupImages">
          <icon-close />
        </button>
        <div ref="popupImagesScroller" class="scroller">
          <img
            :class="'popup-image-' + currentColor.coverImage.checksum"
            :src="processUrl(currentColor.coverImage.fullsize)"
          />
          <img
            :class="'popup-image-' + image.checksum"
            v-for="image in currentColor.images"
            :key="image.checksum"
            :src="processUrl(image.fullsize)"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.popup-image {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  z-index: 200;

  .close {
    position: absolute;
    right: 37px;
    top: 20px;
    background: #fff;
    border: 1px solid $color-border;
    border-radius: 100%;
    padding: 0;
    cursor: pointer;
    padding: 5px;
    transition: color 0.3s, background-color 0.3s, border-color 0.3s;

    &:hover {
      color: #fff;
      background: #000;
      border-color: #000;
    }

    .svg-icon {
      display: block;
    }
  }

  .scroller {
    overflow: auto;
    height: 100%;
  }

  img {
    display: block;
    width: 100%;
    background: #fff;
  }
}
</style>
